import { render, staticRenderFns } from "./customerResources.vue?vue&type=template&id=29eaa99e&scoped=true&"
import script from "./customerResources.vue?vue&type=script&lang=js&"
export * from "./customerResources.vue?vue&type=script&lang=js&"
import style0 from "./customerResources.vue?vue&type=style&index=0&id=29eaa99e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29eaa99e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29eaa99e')) {
      api.createRecord('29eaa99e', component.options)
    } else {
      api.reload('29eaa99e', component.options)
    }
    module.hot.accept("./customerResources.vue?vue&type=template&id=29eaa99e&scoped=true&", function () {
      api.rerender('29eaa99e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/code/batchAddFriends/customerResources.vue"
export default component.exports